import {
 Alert,
 Box,
 Button,
 CircularProgress,
 FormControl,
 Grid,
 IconButton,
 InputAdornment,
 InputLabel,
 MenuItem,
 Select,
 Slider,
 Snackbar,
 Table,
 TableBody,
 TableCell,
 TableRow,
 TextField,
 Typography
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { auth } from "../../../firebase";
import { AttachFile, Close, PictureAsPdf } from "@mui/icons-material";
import ReusableModal from "../Model";
import ReactMarkdown from "react-markdown";

const ExpertView = () => {
 const zones = [
  "Western Himalayas (J & K, H.P.)",
  "Uttarakhand",
  "Eastern Himalaya (Assam,  W.B., NE  states)",
  "Lower Gangatic Plain  (W.B.)",
  "Middle Gangetic Plain  (Eastern  U.P.)",
  "Bihar",
  "Upper Gangetic  Plain  (Western  U.P.)",
  "Trans Gangetic Plain (Punjab)",
  "Haryana",
  "Eastern  Plateau  &  Hills",
  "Chhatisgarh",
  "Jharkhand",
  "Eastern  Maharashtra (Bhandera region)\n& part of Orissa",
  "Central Plateau & Hills",
  "Madhya  Pradesh",
  "U.P. (Bundel Khand)",
  "Maharashtra",
  "Western Plateau (Maharashtra  and Southern  M.P.)",
  "Southern  Plateau",
  "Andhra  Pradesh",
  "Karnataka",
  "Tamil Nadu",
  "East  Coast  Plains  &  Hills",
  "Orissa",
  "West  Coast  Plains &  Ghats",
  "Kerala",
  "Maharashtra  (Konkan)",
  "Gujarat  Plains  &  Hills",
  "Northern Gujarat",
  "Southern  Gujarat",
  "Western Dry Region (Rajasthan)",
  "Island region (Andaman & Nicobar)"
];
const seasons = ["Spring", "Summer", "Autumn", "Winter"];

const [val, setVal] = React.useState({
  temperature: 25,
  humidity: 50,
  nitrogen: 50,
  potassium: 50,
  phosphorus: 50,
  moisture: 20,
  croptype: "Barley",
  soiltype: "Black",
  modeltype: "v2"
});
const [predicted, setPredictedData] = useState("");
const [predictedId, setPredictedDataId] = useState("");
const [predictedGpt, setPredictedDataGpt] = useState("");
const [openModal, setOpenModal] = useState(false);
const [uploadedFiles, setUploadedFiles] = useState([]);
const [feedback, setFeedBack] = useState({
  rating: 0,
  ratingReason: "",
  confidenceLevel: "",
  suggestedNpk: "",
  AgroZone: "",
  Season: ""
});
const [message, setMessage] = useState("");
const [severity, setSeverity] = useState("success");
const [open, setOpen] = useState(false);

const handleFileUpload = event => {
  const files = Array.from(event.target.files);
  setUploadedFiles(prevFiles => [...prevFiles, ...files]);
};

const handleRemoveFile = index => {
  setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
};

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/agri/latest/data`
      );
      if (response.status == 200) {
        setVal(data => ({
          ...data,
          nitrogen: response.data.data[0].nitrogen,
          phosphorus: response.data.data[0].phosphorus,
          potassium: response.data.data[0].potassium,
          temperature: response.data.data[0].temperature,
          humidity: response.data.data[0].humidity
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchData();

  // Optional: Polling every 10 seconds
  // const interval = setInterval(fetchData, 10000);

  // return () => clearInterval(interval); // Cleanup interval on unmount
}, []);

const [loadingApi1, setLoadingApi1] = useState(false);
const [loadingApi2, setLoadingApi2] = useState(false);
const [loadingApi3, setLoadingApi3] = useState(false);
const [predictionshort, setpredictionshort] = useState(false);
const handleSubmitFeedback = async () => {
  setLoadingApi3(true);
  // Prepare FormData
  const formData = new FormData();
  uploadedFiles.forEach(file => formData.append("files", file)); // Ensure backend supports multiple files
  // Append feedback data
  Object.keys(feedback).forEach(key => {
    formData.append(key, feedback[key]);
  });
  formData.append("prediction_id", predictedId);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/fertilizer/recommendation/expert/feedback`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
          "Content-Type": "multipart/form-data"
        }
      }
    );
    if (response.data.message == "Prediction created successfully!") {
      setOpenModal(false);
      setMessage(response.data.message);
      setSeverity("success");
      setOpen(true);
    }

    console.log("Upload Success:", response.data);
  } catch (error) {
    setMessage("some problem occured, please try again");
    setSeverity("error");
    setOpen(true);
    console.error("Upload Error:", error);
  } finally {
    setLoadingApi3(false);
    setFeedBack({
      rating: 0,
      ratingReason: "",
      confidenceLevel: "",
      suggestedNpk: "",
      AgroZone: "",
      Season: ""
    });
  }
};

const [currPrompt, setLatestPrompt] = useState("");
const [updatePrompt, setUpdatedPrompt] = useState("");
const [updateMessage, setUpdatedMessage] = useState("");

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get/latest/prompt`
      );

      if (response.data.status === "Success") {
        setLatestPrompt(response.data.prompt);
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchData();

  // Optional: Polling every 10 seconds
  // const interval = setInterval(fetchData, 10000);

  // return () => clearInterval(interval); // Cleanup interval on unmount
}, [updateMessage]);

const handleUpdate = async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/update/latest/prompt`,
      {
        prompt: currPrompt
      }
    );

    if (response.data.status === "Success") {
      setUpdatedMessage(response.data.message);
    }
  } catch (err) {
    console.log(err);
  }
};

// const handlePrediction = async () => {
//   const response = await axios.post(
//     `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation`,
//     {
//       temperature: val.temperature,
//       humidity: val.humidity,
//       nitrogen: val.nitrogen,
//       potassium: val.potassium,
//       phosphorous: val.phosphorus,
//       croptype: val.croptype,
//       soiltype: val.soiltype,
//       moisture: val.moisture,
//     }
//   );
//   if (response.data.status == "success") {
//     setPredictedData(response.data.data);
//   }
// };

function formatRecommendation(jsonData) {
  if (!jsonData.response) {
    return "No recommendation data available.";
  }

  // Split response into sections based on numbered points (1., 2., 3.)
  const sections = jsonData.response.split(/\n\n(?=\d+\.)/);

  // Format each section into markdown-style text
  let formattedText = `### Optimized Recommendations\n\n`;

  sections.forEach(section => {
    formattedText +=
      section
        .replace(/\*\*(.*?)\*\*/g, "**$1**") // Keep bold formatting
        .replace(/-\s/g, "- ") // Normalize list formatting
        .replace(/\n\s+/g, "\n") + "\n\n"; // Remove unnecessary spaces
  });

  return formattedText.trim();
}

const handleClose = (event, reason) => {
  if (reason === "clickaway") {
    return;
  }
  setOpen(false);
};

const handlePrediction = async () => {
  setOpenModal(true);
  try {
    setLoadingApi1(true);
    setLoadingApi2(true);
    // First API Call: Fertilizer Recommendation
    const api1Promise = axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/id`,
        {
          temperature: val.temperature,
          humidity: val.humidity,
          nitrogen: val.nitrogen,
          potassium: val.potassium,
          phosphorous: val.phosphorus,
          croptype: val.croptype,
          soiltype: val.soiltype,
          moisture: val.moisture,
          modeltype: val.modeltype
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => {
        if (response.data.status === "success") {
          setPredictedDataId(response.data.id);
          setPredictedData(response.data.data); // UI updates immediately
        }
      })
      .catch(error => {
        console.error(
          "First API failed:",
          error.response && error.response.data
            ? error.response.data
            : error.message
        );
      })
      .finally(() => setLoadingApi1(false));

    // Second API Call: GPT-based Recommendation
    const api2Promise = axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/gpt`,
        {
          temperature: val.temperature,
          humidity: val.humidity,
          nitrogen: val.nitrogen,
          potassium: val.potassium,
          phosphorus: val.phosphorus,
          crop_type: val.croptype,
          soil_type: val.soiltype,
          soil_moisture: val.moisture
        }
      )
      .then(response => {
        console.log(formatRecommendation(response.data));
        setPredictedDataGpt(response.data.response);
        console.log("Second API Data:", response.data.response);
      })
      .catch(error => {
        console.error(
          "Second API failed:",
          error.response && error.response.data
            ? error.response.data
            : error.message
        );
      })
      .finally(() => setLoadingApi2(false));

    // Run both APIs in parallel without blocking UI updates
    await Promise.allSettled([api1Promise, api2Promise]);
  } catch (error) {
    console.error("Unexpected error in API calls:", error);
  }
};

const fileInputRef = useRef(null);

const handleChange = e => {
  setVal({ ...val, [e.target.name]: e.target.value });
};

const handleChangeFeedBack = (event, name) => {
  event.persist();
  setFeedBack(prev => ({
    ...prev,
    [name]: event.target.value
  }));
};

  return (
   <>
   <Grid container>
        <Grid item xs={12}>
          <Grid item style={{ marginTop: "3rem", marginBottom: "2.25rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.5rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "1.125rem"
              }}
            >
              Fertilizer Recommendation
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            marginBottom: "1.75rem",
            marginRight: "1rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Temperature ( °C )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: -10,
                    label: ""
                  },
                  {
                    value: val.temperature,
                    label: `${val.temperature}` // Current value label
                  },
                  {
                    value: 50,
                    label: ""
                  }
                ]}
                step={1}
                value={val.temperature}
                name="temperature"
                valueLabelDisplay="off"
                min={-10}
                max={50}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-10px)" // Customize max label position
                  },
                  "& .MuiSlider-markLabel[data-index='2']": {
                    transform: "translateY(6px) translateX(-15px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            marginBottom: "1.75rem",
            marginRight: "1rem",
            borderRadius: "0.75rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Humidity ( %RH )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.humidity,
                    label: `${val.humidity}` // Current value label
                  },
                  {
                    value: 100,
                    label: ""
                  }
                ]}
                step={1}
                value={val.humidity}
                name="humidity"
                valueLabelDisplay="off"
                min={0}
                max={100}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-15px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            marginBottom: "1.75rem",
            borderRadius: "0.75rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Moisture
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.moisture,
                    label: `${val.moisture}` // Current value label
                  },
                  {
                    value: 100,
                    label: ""
                  }
                ]}
                step={1}
                value={val.moisture}
                name="moisture"
                valueLabelDisplay="off"
                min={0}
                max={100}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-15px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            marginRight: "1rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Nitrogen ( mg/kg )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.nitrogen,
                    label: `${val.nitrogen}` // Current value label
                  },
                  {
                    value: 200,
                    label: ""
                  }
                ]}
                step={1}
                value={val.nitrogen}
                name="nitrogen"
                valueLabelDisplay="off"
                min={0}
                max={200}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-7px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            marginRight: "1rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Potassium ( mg/kg )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.potassium,
                    label: `${val.potassium}` // Current value label
                  },
                  {
                    value: 200,
                    label: ""
                  }
                ]}
                step={1}
                value={val.potassium}
                name="potassium"
                valueLabelDisplay="off"
                min={0}
                max={200}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-7px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3.87}
          style={{
            borderRadius: "0.75rem",
            border: "1px solid rgba(245, 138, 32, 0.60)",
            background: "#FFF",
            padding: "1rem",
            boxShadow: `
    1px 1px 2px 0px rgba(255, 255, 255, 0.30) inset,
    -1px -1px 2px 0px rgba(239, 239, 239, 0.50) inset,
    -4px 4px 8px 0px rgba(239, 239, 239, 0.20),
    4px -4px 8px 0px rgba(239, 239, 239, 0.20),
    -4px -4px 8px 0px rgba(255, 255, 255, 0.90),
    4px 4px 10px 0px rgba(239, 239, 239, 0.90)
  `
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "1.25rem" }}>
              <Typography
                variant="h8"
                style={{
                  color: "#181818",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal"
                }}
              >
                Phosphorus ( mg/kg )
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                marks={[
                  {
                    value: 0,
                    label: ""
                  },
                  {
                    value: val.phosphorus,
                    label: `${val.phosphorus}` // Current value label
                  },
                  {
                    value: 200,
                    label: ""
                  }
                ]}
                step={1}
                value={val.phosphorus}
                valueLabelDisplay="off"
                name="phosphorus"
                min={0}
                max={200}
                onChange={e => handleChange(e)}
                sx={{
                  "& .MuiSlider-thumb": {
                    height: "1.5rem", // Thumb height
                    width: "1.5rem", // Thumb width
                    backgroundImage: "url(/thumb.svg)", // Custom image URL
                    backgroundPosition: "center", // Center the image in the thumb
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "none" // Remove the glow effect on hover/focus
                    }
                  },
                  "& .MuiSlider-rail": {
                    height: "1.5rem", // Rail height
                    backgroundColor: "grey", // Non-slided portion color (rail)
                    borderRadius: "0.75rem" // Rounded rail
                  },
                  "& .MuiSlider-track": {
                    height: "1.5rem", // Track height
                    borderRadius: "0.75rem", // Rounded track
                    backgroundColor: "#0E2748" // Active portion color (track)
                  },
                  "& .MuiSlider-markLabel[data-index='0']": {
                    transform: "translateY(6px) translateX(0px)" // Customize min label position
                  },
                  "& .MuiSlider-markLabel[data-index='1']": {
                    transform: "translateY(6px) translateX(-7px)" // Customize max label position
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "2rem" }}>
        <Grid item xs={4}>
          <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal"
              }}
            >
              Soil Type
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={val.soiltype}
              name="soiltype"
              style={{ width: "20rem", height: "4.5rem" }}
              onChange={e => handleChange(e)}
            >
              <MenuItem value="Black">Black</MenuItem>
              <MenuItem value="Clayey">Clayey</MenuItem>
              <MenuItem value="Loamy">Loamy</MenuItem>
              <MenuItem value="Red">Red</MenuItem>
              <MenuItem value="Sandy">Sandy</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal"
              }}
            >
              Crop Type
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={val.croptype}
              name="croptype"
              style={{ width: "20rem", height: "4.5rem" }}
              onChange={e => handleChange(e)}
            >
              <MenuItem value="Barley">Barley</MenuItem>
              <MenuItem value="Cotton">Cotton</MenuItem>
              <MenuItem value="Ground Nuts">Ground Nuts</MenuItem>
              <MenuItem value="Maize">Maize</MenuItem>
              <MenuItem value="Millets">Millets</MenuItem>
              <MenuItem value="Oil seeds">Oil seeds</MenuItem>
              <MenuItem value="Paddy">Paddy</MenuItem>
              <MenuItem value="Pulses">Pulses</MenuItem>
              <MenuItem value="Sugarcane">Sugarcane</MenuItem>
              <MenuItem value="Tobacco">Tobacco</MenuItem>
              <MenuItem value="Wheat">Wheat</MenuItem>
              <MenuItem value="coffee">coffee</MenuItem>
              <MenuItem value="kidneybeans">kidneybeans</MenuItem>
              <MenuItem value="orange">orange</MenuItem>
              <MenuItem value="pomegranate">pomegranate</MenuItem>
              <MenuItem value="rice">rice</MenuItem>
              <MenuItem value="watermelon">watermelon</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid item xs={12} style={{ marginBottom: "0.5rem" }}>
            <Typography
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal"
              }}
            >
              Model Type
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={val.modeltype}
              name="modeltype"
              style={{ width: "20rem", height: "4.5rem" }}
              onChange={e => handleChange(e)}
            >
              {/* <MenuItem value="v1">V1</MenuItem> */}
              <MenuItem value="v2">V1</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "2.13rem" }}>
          <Button
            variant="contained"
            onClick={handlePrediction}
            style={{
              display: "flex",
              width: "8.75rem",
              padding: "1rem 1.5rem",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.25rem",
              borderRadius: "0.5rem",
              background: "#006BE0"
            }}
          >
            Predict
          </Button>
        </Grid>
        <ReusableModal
          width="97.083vw"
          height = "100%"
           open={openModal} 
           onClose={() => {
             setOpenModal(false);
             setFeedBack({
               rating: 0,
               ratingReason: "",
               confidenceLevel: "",
               suggestedNpk: "",
               AgroZone: "",
               Season: ""
             });
           }}
         >
           <Box>
             <Grid container>
               <Grid item xs={6} sx={{ background: '#FFFFFF', paddingTop: '1.19rem'}}>
                 <Grid container>
                   <Grid item xs={12} sx={{paddingBottom: '2.69rem'}}>
                     <div
                       style={{
                         paddingLeft: "1rem",
                         alignItems: "center",
                         display: "flex"
                       }}
                     >
                       <svg
                         xmlns="http://www.w3.org/2000/svg"
                         width="24"
                         height="24"
                         viewBox="0 0 24 24"
                         fill="none"
                       >
                         <path
                           d="M10.8333 6.16634H13.1666V8.49967H10.8333V6.16634ZM12 17.833C12.6416 17.833 13.1666 17.308 13.1666 16.6663V11.9997C13.1666 11.358 12.6416 10.833 12 10.833C11.3583 10.833 10.8333 11.358 10.8333 11.9997V16.6663C10.8333 17.308 11.3583 17.833 12 17.833ZM12 0.333008C5.55998 0.333008 0.333313 5.55967 0.333313 11.9997C0.333313 18.4397 5.55998 23.6663 12 23.6663C18.44 23.6663 23.6666 18.4397 23.6666 11.9997C23.6666 5.55967 18.44 0.333008 12 0.333008ZM12 21.333C6.85498 21.333 2.66665 17.1447 2.66665 11.9997C2.66665 6.85467 6.85498 2.66634 12 2.66634C17.145 2.66634 21.3333 6.85467 21.3333 11.9997C21.3333 17.1447 17.145 21.333 12 21.333Z"
                           fill="black"
                         />
                       </svg>
                       <span
                         style={{
                           marginLeft: "0.25rem",
                           color: "rgba(0, 0, 0, 0.80)",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.5rem",
                           fontStyle: "normal",
                           fontWeight: 600,
                           lineHeight: "1.125rem"
                         }}
                       >
                         Summary
                       </span>
                     </div>
                   </Grid>
                 </Grid>
                 <Grid container>
                   <Box
                     sx={{
                       overflowY: "auto",
                       maxHeight: "500px",
                       padding: "1rem",
                       width: "100%" // Ensures full width inside the Grid container
                     }}
                   >
                     <Grid item xs={12}>
                       <span
                         style={{
                           color: "#000",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.125rem",
                           fontStyle: "normal",
                           fontWeight: 600,
                           lineHeight: "1.125rem"
                         }}
                       >
                         Prediction summary based on the selected value:
                       </span>
                     </Grid>
                     <Grid item xs={12} style={{ marginTop: "1.25rem" }}>
                       <Grid container>
                         <Grid item>
                           <Box
                             sx={{
                               position: "relative",
                               display: "inline-block",
                               border: "1px solid #ADADAD",
                               borderRadius: "0.25rem",
                               overflow: "hidden"
                             }}
                           >
                             <Table>
                               <TableBody>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.333vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderRight: "1px solid #ADADAD",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Temperature
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["temperature"]}°C`}
                                   </TableCell>
                                 </TableRow>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD",
                                       borderRight: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Humidity
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["humidity"]}`}
                                   </TableCell>
                                 </TableRow>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD",
                                       borderRight: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Moisture
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["moisture"]}`}
                                   </TableCell>
                                 </TableRow>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderRight: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Soil type
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["soiltype"]}`}
                                   </TableCell>
                                 </TableRow>
                               </TableBody>
                             </Table>
                           </Box>
                         </Grid>
                         <Grid item style={{ marginLeft: "1.25rem" }}>
                           <Box
                             sx={{
                               position: "relative",
                               display: "inline-block",
                               border: "1px solid #ADADAD",
                               borderRadius: "0.25rem",
                               overflow: "hidden"
                             }}
                           >
                             <Table>
                               <TableBody>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderRight: "1px solid #ADADAD",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Nitrogen
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["nitrogen"]}`}
                                   </TableCell>
                                 </TableRow>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderRight: "1px solid #ADADAD",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Potassium
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["potassium"]}`}
                                   </TableCell>
                                 </TableRow>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderRight: "1px solid #ADADAD",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Phosphorus
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem",
                                       borderBottom: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["phosphorus"]}`}
                                   </TableCell>
                                 </TableRow>
                                 <TableRow>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#F9FBFC",
                                       gap: "0.625rem",
                                       borderRight: "1px solid #ADADAD"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 600,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     Crop type
                                   </TableCell>
                                   <TableCell
                                     style={{
                                       width: "8.33vw",
                                       height: "2.5rem",
                                       padding: "0.625rem 0.5rem",
                                       alignItems: "center",
                                       backgroundColor: "#FFF",
                                       gap: "0.625rem"
                                     }}
                                     sx={{
                                       color: "#232323",
                                       fontFamily: "Inter",
                                       fontSize: "0.875rem",
                                       fontStyle: "normal",
                                       fontWeight: 400,
                                       lineHeight: "1.125rem"
                                     }}
                                   >
                                     {`${val["croptype"]}`}
                                   </TableCell>
                                 </TableRow>
                               </TableBody>
                             </Table>
                           </Box>
                         </Grid>
                       </Grid>
                     </Grid>
                     <Grid item xs={12} style={{ marginTop: "1.87rem" }}>
                       <Box
                         sx={{
                           position: "relative",
                           display: "inline-block",
                           border: "1px solid #ADADAD",
                           borderRadius: "0.25rem",
                           overflow: "hidden"
                         }}
                       >
                         <Table>
                           <TableBody>
                             <TableRow>
                               <TableCell
                                 style={{
                                   width: "8.33vw",
                                   height: "2.5rem",
                                   padding: "0.625rem 0.5rem",
                                   alignItems: "center",
                                   backgroundColor: "#F9FBFC",
                                   gap: "0.625rem",
                                   borderRight: "1px solid #ADADAD",
                                   borderBottom: "1px solid #ADADAD"
                                 }}
                                 sx={{
                                   color: "#232323",
                                   fontFamily: "Inter",
                                   fontSize: "0.875rem",
                                   fontStyle: "normal",
                                   fontWeight: 600,
                                   lineHeight: "1.125rem"
                                 }}
                               >
                                 Predicted Fertilizer
                               </TableCell>
                               <TableCell
                                 style={{
                                   width: "8.33vw",
                                   height: "2.5rem",
                                   padding: "0.625rem 0.5rem",
                                   alignItems: "center",
                                   backgroundColor: "#FFF",
                                   gap: "0.625rem",
                                   borderRight: "1px solid #ADADAD",
                                   borderBottom: "1px solid #ADADAD"
                                 }}
                                 sx={{
                                   color: "#232323",
                                   fontFamily: "Inter",
                                   fontSize: "0.875rem",
                                   fontStyle: "normal",
                                   fontWeight: 400,
                                   lineHeight: "1.125rem"
                                 }}
                               >
                                 {`N-P-K : ${predicted}`}
                               </TableCell>
                             </TableRow>
                           </TableBody>
                         </Table>
                       </Box>
                     </Grid>
                     <Grid
                       item
                       xs={12}
                       style={{
                         marginTop: "2.25rem"
                       }}
                     >
                       <Typography
                         sx={{
                           color: "#000",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.125rem",
                           fontStyle: "normal",
                           fontWeight: 600,
                           lineHeight: "1.125rem" /* 100% */
                         }}
                       >
                         Fertilizer Recommendation :
                       </Typography>
                     </Grid>
                     <Grid item xs={12}>
                       {loadingApi2 ? (
                         <Grid
                           item
                           xs={12}
                           style={{
                             display: "flex",
                             justifyContent: "center",
                             marginTop: "3.5rem"
                           }}
                         >
                           <CircularProgress
                             sx={{ color: "#0E2748" }}
                             size={26}
                           />
                         </Grid>
                       ) : (
                         predictedGpt && (
                           <>
                             {/* <Grid container mt={2}>
                               <Grid
                                 item
                                 xs={12}
                                 style={{ marginTop: "1.25rem" }}
                               >
                                 <TextField
                                   label="Current Prompt"
                                   fullWidth
                                   variant="outlined"
                                   value={currPrompt}
                                   onChange={e =>
                                     setLatestPrompt(e.target.value)
                                   }
                                   multiline
                                   maxRows={10} // Adjust this based on your needs
                                 />
                               </Grid>
                               <Grid
                                 item
                                 xs={12}
                                 style={{ marginTop: "1.25rem" }}
                               >
                                 <Button
                                   onClick={handleUpdate}
                                   variant="contained"
                                 >
                                   Update Prompt
                                 </Button>
                               </Grid>
                             </Grid> */}
                             <div
                               item
                               xs={12}
                               style={{
                                 paddingBottom: "1rem",
                                 paddingTop: "1.25rem",
                                 backgroundColor: "#fff",
                               }}
                             >
                               {/* <Typography
                                 variant="body1"
                                 style={{
                                   fontSize: "1rem",
                                   lineHeight: "1.5",
                                   color: "#333",
                                   whiteSpace: "pre-line"
                                 }}
                               >
                                 {predictedGpt.replaceAll("###", "\n")}
                               </Typography> */}
                               <section style={{
                                                                     fontSize: "1rem",
                                                                     lineHeight: "1.5",
                                                                     color: "#333",
                                                                     whiteSpace: "pre-line"
                                                                   }}><ReactMarkdown>{predictedGpt}</ReactMarkdown></section>
                             </div>
                           </>
                         )
                       )}
                     </Grid>
                   </Box>
                 </Grid>
               </Grid>
               <Grid item xs={6} sx={{ background: '#F9FBFC', paddingTop: '0.87rem'}}>
                 <Grid container>
                   <Grid item xs={12} sx={{paddingBottom: '3rem'}}>
                     <div
                       style={{
                         justifyContent: "center",
                         alignItems: "center",
                         display: "flex"
                       }}
                     >
                       <Typography
                         sx={{
                           color: "rgba(0, 0, 0, 0.80)",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.5rem",
                           fontStyle: "normal",
                           fontWeight: 600,
                           lineHeight: "1.125rem"
                         }}
                       >
                         FeedBack
                       </Typography>
                     </div>
                   </Grid>
                 </Grid>
                 <Grid container >
                   <Box
                     sx={{
                       overflowY: "auto",
                       maxHeight: "500px",
                       padding: "1rem",
                       width: "100%" // Ensures full width inside the Grid container
                     }}
                   >
                     <Grid item xs={12} sx={{ marginBottom: "1.12rem"}}>
                       <Typography
                         sx={{
                           color: "#000",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.25rem",
                           fontStyle: "normal",
                           fontWeight: 500,
                           lineHeight: "1.125rem"
                         }}
                       >
                         1: Please rate the accuracy of the Model’s prediction:{" "}
                         <Typography component="span" sx={{ color: "#FF3B30" }}>
                           *
                         </Typography>
                       </Typography>
                     </Grid>
                     <Grid item xs={12} sx={{ marginBottom: "1.12rem" }}>
                       <Grid container>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 1 ? 0 : 1 }))
 
                           }
                           sx={{
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 1 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 1 ? "#D32F2F" : feedback["rating"] == 0 ? "#D32F2F":"#FFF" ,
                             color:
                               feedback["rating"] == 1 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             transition: "transform 0.2s ease-in-out",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           1
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 2 ? 0 : 2 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 2 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 2 ? "#F44336" : feedback["rating"] == 0 ? "#F44336":"#FFF" ,
                             color:
                               feedback["rating"] == 2 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             transition: "transform 0.2s ease-in-out",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           2
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 3 ? 0 : 3 }))
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 3 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 3 ? "#FF5722" : feedback["rating"] == 0 ? "#FF5722":"#FFF" ,
                             color:
                               feedback["rating"] == 3 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             transition: "transform 0.2s ease-in-out",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           3
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 4 ? 0 : 4 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 4 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 4 ? "#FF9800" : feedback["rating"] == 0 ? "#FF9800":"#FFF" ,
                             color:
                               feedback["rating"] == 4 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             transition: "transform 0.2s ease-in-out",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           4
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 5 ? 0 : 5 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 5 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 5 ? "#FFEB3B" : feedback["rating"] == 0 ? "#FFEB3B":"#FFF" ,
                             color:
                               feedback["rating"] == 5 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             fontStyle: "normal",
                             transition: "transform 0.2s ease-in-out",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           5
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 6 ? 0 : 6 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 6 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 6 ? "#CDDC39" : feedback["rating"] == 0 ? "#CDDC39":"#FFF" ,
                             color:
                               feedback["rating"] == 6 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             transition: "transform 0.2s ease-in-out",
                             fontSize: "0.875rem",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           6
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 7 ? 0 : 7 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 7 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 7 ? "#8BC34A" : feedback["rating"] == 0 ? "#8BC34A":"#FFF" ,
                             color:
                               feedback["rating"] == 7 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             transition: "transform 0.2s ease-in-out",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           7
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 8 ? 0 : 8 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 8 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 8 ? "#4CAF50" : feedback["rating"] == 0 ? "#4CAF50":"#FFF" ,
                             color:
                               feedback["rating"] == 8 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem", 
                             transition: "transform 0.2s ease-in-out",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           8
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 9 ? 0 : 9 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 9 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 9 ? "#388E3C" : feedback["rating"] == 0 ? "#388E3C":"#FFF" ,
                             color:
                               feedback["rating"] == 9 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             transition: "transform 0.2s ease-in-out",
                             fontSize: "0.875rem",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           9
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({ ...prev, rating: prev.rating === 10 ? 0 : 10 }))
 
                           }
                           sx={{
                             marginLeft: "1rem",
                             display: "flex",
                             width: "2.5rem",
                             height: "2.5rem",
                             padding: "0.625rem 0.5rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             transition: "transform 0.2s ease-in-out",
                             borderRadius: "0.25rem",
                             border: feedback["rating"] == 10 ? "none": feedback["rating"] == 0 ? "none": "1px solid #828282",
                             background:
                               feedback["rating"] == 10 ? "#2E7D32" : feedback["rating"] == 0 ? "#2E7D32":"#FFF" ,
                             color:
                               feedback["rating"] == 10 ? "#FFFFFF" : feedback["rating"] == 0 ? "#FFFFFF": "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem",
                             cursor: "pointer",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           10
                         </Grid>
                       </Grid>
                     </Grid>
 
                     <Grid
                       item
                       xs={12}
                       sx={{ marginTop: "2.12rem", marginBottom: "1.13rem" }}
                     >
                       <Typography
                         sx={{
                           color: "#000",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.25rem",
                           fontStyle: "normal",
                           fontWeight: 500,
                           lineHeight: "1.125rem"
                         }}
                       >
                         2: Based on your rating, please share the reason behind
                         your choice :{" "}
                         <Typography component="span" sx={{ color: "#FF3B30" }}>
                           *
                         </Typography>
                       </Typography>
                     </Grid>
                     <Grid item>
                       <TextField
                         multiline
                         name="ratingReason"
                         rows={4}
                         // value={feedback['ratingReason']}
                         placeholder="Type something here..."
                         sx={{
                           width: "40.125rem",
                           flexShrink: 0,
                           borderRadius: "0.25rem",
                           border: "1px solid #C0C0C0",
                           background: "#FFF",
                           boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.10)",
                           color: "#555",
                           fontFamily: "Inter",
                           fontSize: "0.875rem",
                           fontStyle: "normal",
                           fontWeight: 400,
                           lineHeight: "1.125rem",
                           "& .MuiOutlinedInput-root": {
                             borderRadius: "0.25rem"
                           }
                         }}
                         onChange={e => handleChangeFeedBack(e, "ratingReason")}
                       />
                     </Grid>
                     <Grid
                       item
                       xs={12}
                       sx={{ marginTop: "2.12rem", marginBottom: "1.13rem" }}
                     >
                       <Typography
                         sx={{
                           color: "#000",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.25rem",
                           fontStyle: "normal",
                           fontWeight: 500,
                           lineHeight: "1.125rem"
                         }}
                       >
                         3: Attach a reference link or upload the research paper
                         :
                       </Typography>
                     </Grid>
                     <Grid item sx={{ width: "28.6875rem" }}>
                       <TextField
                         variant="outlined"
                         disabled
                         placeholder="Reference link here..."
                         fullWidth
                         InputProps={{
                           endAdornment: (
                             <InputAdornment position="end">
                               <IconButton
                                 onClick={() => fileInputRef.current.click()}
                               >
                                 <AttachFile style={{ color: "#555" }} />
                               </IconButton>
                             </InputAdornment>
                           ),
                           style: {
                             borderRadius: "0.25rem",
                             border: "1px solid #828282",
                             background: "#FFF",
                             color: "#555",
                             fontSize: "0.875rem",
                             height: "2.5rem"
                           }
                         }}
                       />
                       <input
                         type="file"
                         ref={fileInputRef}
                         style={{ display: "none" }}
                         multiple
                         onChange={handleFileUpload}
                       />
                       <Box display="flex" flexWrap="wrap" mt={2} gap={2}>
                         {uploadedFiles.map((file, index) => (
                           <Box key={index} display="flex" alignItems="center">
                             <PictureAsPdf
                               style={{
                                 fontSize: "2rem",
                                 marginRight: "4px",
                                 color: "#D32F2F"
                               }}
                             />
                             <Typography
                               variant="body2"
                               color="primary"
                               style={{
                                 cursor: "pointer",
                                 textDecoration: "underline"
                               }}
                             >
                               {file.name}
                             </Typography>
                             <IconButton
                               size="small"
                               onClick={() => handleRemoveFile(index)}
                             >
                               <Close
                                 fontSize="small"
                                 style={{ color: "red" }}
                               />
                             </IconButton>
                           </Box>
                         ))}
                       </Box>
                     </Grid>
                     <Grid
                       item
                       xs={12}
                       sx={{ marginTop: "2.12rem", marginBottom: "1.13rem" }}
                     >
                       <Typography
                         sx={{
                           color: "#000",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.25rem",
                           fontStyle: "normal",
                           fontWeight: 500,
                           lineHeight: "1.125rem"
                         }}
                       >
                         4: Confidence level of your recommendation :{" "}
                         <Typography component="span" sx={{ color: "#FF3B30" }}>*</Typography>
                       </Typography>
                     </Grid>
                     <Grid item xs={12}>
                       <Grid container>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({
                               ...prev,
                               confidenceLevel: "Low"
                             }))
                           }
                           sx={{
                             display: "flex",
                             width: "5.3125rem",
                             height: "2.5rem",
                             padding: "0.625rem 1rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["confidenceLevel"] == "Low"  ? "none": "1px solid #828282",
                             background:
                               feedback["confidenceLevel"] == "Low"
                                 ? "#D32F2F"
                                 : "#FFF",
                             color:
                               feedback["confidenceLevel"] == "Low"
                                 ? "#FFFFFF"
                                 : "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem" /* 128.571% */,
                             transition: "transform 0.2s ease-in-out, font-size 0.2s ease-in-out",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           Low
                         </Grid>
 
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({
                               ...prev,
                               confidenceLevel: "Medium"
                             }))
                           }
                           sx={{
                             marginLeft: "1.25rem",
                             display: "flex",
                             width: "5.3125rem",
                             height: "2.5rem",
                             padding: "0.625rem 1rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["confidenceLevel"] == "Medium"  ? "none": "1px solid #828282",
                             background:
                               feedback["confidenceLevel"] == "Medium"
                                 ? "#FFEB3B"
                                 : "#FFF",
                             color:
                               feedback["confidenceLevel"] == "Medium"
                                 ? "#FFFFFF"
                                 : "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem" /* 128.571% */,
                             transition: "transform 0.2s ease-in-out, font-size 0.2s ease-in-out",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           Medium
                         </Grid>
                         <Grid
                           item
                           onClick={() =>
                             setFeedBack(prev => ({
                               ...prev,
                               confidenceLevel: "High"
                             }))
                           }
                           sx={{
                             marginLeft: "1.25rem",
                             display: "flex",
                             width: "5.3125rem",
                             height: "2.5rem",
                             padding: "0.625rem 1rem",
                             justifyContent: "center",
                             alignItems: "center",
                             gap: "0.625rem",
                             flexShrink: 0,
                             borderRadius: "0.25rem",
                             border: feedback["confidenceLevel"] == "High"  ? "none": "1px solid #828282",
                             background:
                               feedback["confidenceLevel"] == "High"
                                 ? "#2E7D32"
                                 : "#FFF",
                             color:
                               feedback["confidenceLevel"] == "High"
                                 ? "#FFFFFF"
                                 : "#232323",
                             cursor: "pointer",
                             fontFamily: "Inter",
                             fontSize: "0.875rem",
                             fontStyle: "normal",
                             fontWeight: 400,
                             lineHeight: "1.125rem" /* 128.571% */,
                             transition: "transform 0.2s ease-in-out, font-size 0.2s ease-in-out",
                             "&:hover": {
                               transform: "scale(1.1)",
                             }
                           }}
                         >
                           High
                         </Grid>
                       </Grid>
                     </Grid>
 
                     <Grid
                       item
                       xs={12}
                       sx={{ marginTop: "2.12rem", marginBottom: "1.13rem" }}
                     >
                       <Typography
                         sx={{
                           color: "#000",
                           fontFeatureSettings:
                             "'ss01' on, 'cv01' on, 'cv11' on",
                           fontFamily: "Inter",
                           fontSize: "1.25rem",
                           fontStyle: "normal",
                           fontWeight: 500,
                           lineHeight: "1.125rem"
                         }}
                       >
                         5: If you disagree with the model's output, please
                         suggest an alternative N-P-K ratio :
                       </Typography>
                     </Grid>
                     <Grid
                       item
                       sx={{
                         display: "flex",
                         width: "11.875rem",
                         height: "2.5rem",
                         padding: "0.625rem 1rem",
                         alignItems: "center",
                         gap: "0.625rem",
                         flexShrink: 0,
                         borderRadius: "0.25rem",
                         border: "1px solid #828282",
                         background: "#FFF",
                         color: "#555",
                         fontFamily: "Inter",
                         fontSize: "0.875rem",
                         fontStyle: "normal",
                         fontWeight: 400,
                         lineHeight: "1.125rem",
                         "& .MuiOutlinedInput-root": {
                           "& fieldset": {
                             border: "none"
                           },
                           "& input": {
                             paddingLeft: "2px"
                           }
                         }
                       }}
                     >
                       <TextField
                         placeholder="N-P-K ratio"
                         value={feedback.suggestedNpk}
                         onChange={e => handleChangeFeedBack(e, "suggestedNpk")}
                       />
                     </Grid>
                     {feedback.suggestedNpk.length > 0 && (
                       <>
                         <Grid
                           item
                           xs={12}
                           sx={{
                             marginTop: "2.12rem",
                             marginBottom: "1.13rem"
                           }}
                         >
                           <Typography
                             sx={{
                               color: "#000",
                               fontFeatureSettings:
                                 "'ss01' on, 'cv01' on, 'cv11' on",
                               fontSize: "1.25rem",
                               fontStyle: "normal",
                               fontWeight: 500,
                               lineHeight: "1.125rem" // 90%
                             }}
                           >
                             6: Based on suggested alternative N-P-K ratio,
                             please choose the region and season :
                           </Typography>
                         </Grid>
                         <Grid item xs={12}>
                           <Grid container>
                             <Grid item>
                               <Box sx={{ minWidth: 200 }}>
                                 <FormControl fullWidth variant="outlined">
                                   <InputLabel id="demo-simple-select-label">
                                     Agro-climatic region
                                   </InputLabel>
                                   <Select
                                     // style={{height: '2.5rem'}}
                                     required
                                     labelId="demo-simple-select-label"
                                     label="Agro-climatic region"
                                     onChange={e =>
                                       setFeedBack(prev => ({
                                         ...prev,
                                         AgroZone: e.target.value
                                       }))
                                     }
                                   >
                                     {zones.map((zone, index) => (
                                       <MenuItem
                                         index={index}
                                         value={zone}
                                         name={zone}
                                       >
                                         {zone}
                                       </MenuItem>
                                     ))}
                                   </Select>
                                 </FormControl>
                               </Box>
                             </Grid>
                             <Grid item sx={{ marginLeft: "0.62rem" }}>
                               <Box sx={{ minWidth: 200, height: "2.5rem" }}>
                                 <FormControl fullWidth variant="outlined">
                                   <InputLabel id="demo-simple-select-label">
                                     Season
                                   </InputLabel>
                                   <Select
                                     labelId="demo-simple-select-label"
                                     label="Season"
                                     // style={{height: '2.5rem'}}
                                     required
                                     onChange={e =>
                                       setFeedBack(prev => ({
                                         ...prev,
                                         Season: e.target.value
                                       }))
                                     }
                                   >
                                     {seasons.map((season, index) => (
                                       <MenuItem
                                         index={index}
                                         value={season}
                                         name={season}
                                       >
                                         {season}
                                       </MenuItem>
                                     ))}
                                   </Select>
                                 </FormControl>
                               </Box>
                             </Grid>
                           </Grid>
                         </Grid>
                       </>
                     )}
                   </Box>
                 </Grid>
               </Grid>
             </Grid>
             <Grid container style={{ paddingTop: "1rem" }}>
               <Grid
                 item
                 xs={12}
                 style={{ display: "flex", justifyContent: "flex-end" }}
               >
                 <Button
                   onClick={
                     () => {
                           setFeedBack({
                             rating: 0,
                             ratingReason: "",
                             confidenceLevel: "",
                             suggestedNpk: "",
                             AgroZone: "",
                             Season: ""
                           });
                           setOpenModal(false);
                         }
                   }
                   sx={{
                     display: "flex",
                     width: "8.75rem",
                     padding: "1rem 1.5rem",
                     justifyContent: "center",
                     alignItems: "center",
                     gap: "0.25rem",
                     borderRadius: "0.5rem",
                     textTransform: "none",
                     border: "1px solid #C84146",
                     marginRight: "1.5rem",
                     color: "#C84146",
                     fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                     fontSize: "0.875rem",
                     fontStyle: "normal",
                     fontWeight: 600,
                     lineHeight: "1.125rem"
                   }}
                 >
                   Close
                 </Button>
 
                 <Button
                   variant="contained"
                   sx={{
                     display: "flex",
                     width: "8.75rem",
                     whiteSpace: "nowrap",
                     padding: "1rem 1.5rem",
                     justifyContent: "center",
                     alignItems: "center",
                     gap: "0.25rem",
                     borderRadius: "0.5rem",
                     color: "#FFF",
                     textTransform: "none",
                     fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                     fontSize: "0.875rem",
                     fontStyle: "normal",
                     fontWeight: 600,
                     lineHeight: "1.125rem"
                   }}
                   onClick={() =>
                     handleSubmitFeedback()
                   }
                 >
                   {loadingApi3 ? (
                     <CircularProgress sx={{ color: "#fff" }} size={26} />
                   ) : "Submit"
                   }
                   {/* {openFeedBack ? "Submit" : "Send Feedback"} */}
                 </Button>
               </Grid>
             </Grid>
           </Box>
         </ReusableModal>
<Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>
      </Grid>
   
   </>
  )
}


export default ExpertView